import {validateProperty} from './validate_property';

export function validatePaintProperty(options) {
    return validateProperty(options, 'paint');
}
